/* eslint-disable unicorn/no-array-for-each */
/* eslint-disable unicorn/no-negated-condition */
/* eslint-disable unicorn/prefer-structured-clone */
import {
  GET_COLLABORATION_COMMENTS_ROUTINE,
  NEW_COLLABORATION_COMMENT_RECEIVED,
  COLLABORATION_COMMENT_EDITED,
  CLEAN_STORE_COMMENTS,
  COLLABORATION_COMMENTS_LOADING_ON,
  COLLABORATION_COMMENTS_LOADING_OFF,
} from "constants/ActionTypes";
import { createReducer } from "@reduxjs/toolkit";
import { ReduxRootState } from "../../types/redux-store";
import { ColComment, ColComments } from "../../components/Collaboration/types";

type State = ReduxRootState["entities"]["colActiveChannels"];
const initialState = {} as State;

export const colActiveChannelsReducer = createReducer(initialState, {
  // set loader when requested comments
  [COLLABORATION_COMMENTS_LOADING_ON]: (
    state: State,
    action: { payload: { channelId?: string } }
  ) => {
    const { channelId } = action.payload || {};
    if (!channelId) {
      return state;
    }

    return {
      ...state,
      [channelId]: { ...state[channelId], isRequestingComments: true },
    };
  },
  [COLLABORATION_COMMENTS_LOADING_OFF]: (
    state: State,
    action: { payload: { channelId?: string } }
  ) => {
    const { channelId } = action.payload || {};
    if (!channelId) {
      return state;
    }

    return {
      ...state,
      [channelId]: { ...state[channelId], isRequestingComments: false },
    };
  },

  [GET_COLLABORATION_COMMENTS_ROUTINE.SUCCESS]: (
    state: State,
    action: { payload: { channelId?: string; comments: ColComments } }
  ) => {
    const { channelId, comments } = action.payload;
    if (!channelId) {
      return state;
    }

    return {
      ...state,
      [channelId]: { ...state[channelId], comments },
    };
  },

  [NEW_COLLABORATION_COMMENT_RECEIVED]: (
    state: State,
    action: {
      payload: { comment: ColComment; userId: string; channelId?: string };
    }
  ) => {
    const { comment, userId, channelId } = action.payload;
    if (!channelId) {
      return state;
    }
    const channelState = state[channelId];

    if (
      !channelState ||
      [
        ...(channelState.comments?.activeThread || []),
        ...(channelState.comments?.legacyThread || []),
      ].some((c) => c._id === comment._id)
    ) {
      return state;
    }
    let activeThread = [
      ...(channelState?.comments?.activeThread || []),
      comment,
    ];
    // mark all comments as read
    activeThread = activeThread.map((comm) => {
      if (!comm.readBy.includes(userId)) {
        return { ...comm, readBy: [...comm.readBy, userId] };
      }
      return comm;
    });
    return {
      ...state,
      [channelId]: {
        ...channelState,
        comments: { ...channelState.comments, activeThread },
      },
    };
  },
  [COLLABORATION_COMMENT_EDITED]: (
    state: State,
    action: { payload: { comment: ColComment; channelId?: string } }
  ) => {
    const { comment, channelId } = action.payload;
    if (!channelId) {
      return state;
    }
    const channelState = state[channelId];
    const activeThread = (channelState.comments?.activeThread || []).map(
      (existingComment) =>
        existingComment._id === comment._id ? comment : existingComment
    );
    return {
      ...state,
      [channelId]: {
        ...channelState,
        comments: { ...channelState.comments, activeThread },
      },
    };
  },
  [CLEAN_STORE_COMMENTS]: (
    state: State,
    action: { payload: { channelId: string } }
  ) => {
    const { channelId } = action.payload;
    if (!channelId) {
      return state;
    }
    const newState = { ...state };
    delete newState[channelId];
    return newState;
  },
});
